import { render } from "./iconBarcode.vue?vue&type=template&id=693b7bf6"
import script from "./iconBarcode.vue?vue&type=script&lang=js"
export * from "./iconBarcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__